import {Component, input, effect, output} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TableComponent } from "../../../../../utils/table/table.component";
import { TableColumnModel } from '../../../../../../models/table-column.model';
import { AResourceTableComponent } from '../../../../../AResourceTableComponent';
import { FormGroupHelper } from '../../../../../../helpers/form-group-helper';

import { VehicleModel } from '../../../../../../models/resources/vehicle.model';
import { HttpErrorsService } from '../../../../../../services/utils/http-errors.service';
import { CustomNotificationService } from '../../../../../../services/utils/custom-notification.service';
import { LocationModel } from "../../../../../../models/resources/location.model";
import {LocationVehicleService} from "../../../../../../services/resources/location-vehicle.service";
import {finalize} from "rxjs";

@Component({
  selector: 'app-location-vehicles-table',
  imports: [
    TableComponent,
    ReactiveFormsModule
  ],
  template: `<app-table
    [columns]="tableColumns"
    [data]="models()"
    [filterFormGroup]="filterFormGroup"
    [loading]="resourceService.loading()"
    (doFilterRequest)="resourceService.getAll($event)"
    (urlParamsChange)="this.urlParams = $event"
    [hasActiveFilters]="resourceService.apiResponse().filters != undefined"
    [pagination]="resourceService.paginationMeta()"
    [deleteLoadingIds]="this.deleteLoadingIds()"
    />`,
  styles: ``,
})
export class LocationVehiclesTableComponent extends AResourceTableComponent<VehicleModel> {
  location = input<LocationModel>();
  vehicle = input<VehicleModel>();
  vehicleUnlinked = output<void>();

  filterFormGroup: FormGroup = FormGroupHelper.createFilterFormGroup(this.formBuilder,[])

  tableColumns: TableColumnModel[] = [
    {
      name: 'VEHICLES.NAME',
      selector: [{ selector: 'name' }],
      filterFormControl: this.filterFormGroup.get('name'),
      filterFormControlLabel: 'VEHICLES.NAME',
      filterUrlParam: 'name'
    },
    {
      name: 'VEHICLES.DESCRIPTION',
      selector: [{ selector: 'description' }]
    },
    {
      name: 'VEHICLES.CAPACITY',
      selector: [{ selector: 'capacity' }],
      filterFormControl: this.filterFormGroup.get('capacity'),
      filterFormControlLabel: 'VEHICLES.CAPACITY',
      filterUrlParam: 'capacity'
    },
    {
      buttons: [
        {
          iconClass: 'fas fa-external-link-alt fa-lg',
          floating: true,
          outlined: true,
          customLink: '/vehicles/{id}'
        },
        {
          iconClass: 'fas fa-trash fa-lg',
          floating: true,
          outlined: true,
          color: 'danger',
          isDelete: true,
          onClick: ($event) => this.delete($event)
        }
      ]
    }
  ]
  constructor(
    formBuilder: FormBuilder,
    public locationVehicleService: LocationVehicleService,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService,
  ) {
    super(formBuilder,
      locationVehicleService,
      httpErrorsService,
      notificationService,
      'VEHICLES')

    effect(() => {
      if(!this.location())
        return

      this.locationVehicleService.setLocationId(this.location()!.id);
    })
  }
  override delete(vehicleId: number){
    const vehicle = this.models().find((m) => m.id == vehicleId);
    if (!vehicle) return;

    this.deleteLoadingIds.update((ids) => {
      return [...ids, +vehicleId];
    });

    this.locationVehicleService
      .update(vehicle.id, {
        ...vehicle,
        location: null,
      }, '/vehicles')
      .pipe(
        finalize(() => {
          // remove id from loading ids array
          this.deleteLoadingIds.update((ids) => {
            return ids.filter((i) => i != vehicleId);
          });
        }),
      )
      .subscribe({
        next: () => {
          this.notificationService.success('LOCATIONS.VEHICLE_SUCCESSFULLY_DELETED');
          this.locationVehicleService.removeModel(vehicleId);
          this.vehicleUnlinked.emit();

        },
        error: (e) => {
          this.httpErrorsService.handleError(e);
        }
      })
  }
}

